/**
 * @generated SignedSource<<815b4fde78cb1c7b6796ec7526d22771>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrandMessagePreview_brandMessagePreview$data = {
  readonly messages: ReadonlyArray<{
    readonly additionalContent: string | null;
    readonly buttons: ReadonlyArray<{
      readonly linkIos: string | null;
      readonly linkMobile: string | null;
      readonly linkType: string;
      readonly name: string;
    }> | null;
    readonly carousel: any | null;
    readonly chatBubbleType: ChatBubbleTypeEnum | null;
    readonly commerce: any | null;
    readonly content: string;
    readonly coupon: {
      readonly description: string;
      readonly linkAndroid: string | null;
      readonly linkIos: string | null;
      readonly linkMobile: string | null;
      readonly linkPc: string | null;
      readonly title: string;
    } | null;
    readonly header: string | null;
    readonly imageLink: string | null;
    readonly imageUrl: string | null;
    readonly to: string;
    readonly video: any | null;
    readonly wideItemList: any | null;
  }>;
  readonly " $fragmentType": "BrandMessagePreview_brandMessagePreview";
};
export type BrandMessagePreview_brandMessagePreview$key = {
  readonly " $data"?: BrandMessagePreview_brandMessagePreview$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessagePreview_brandMessagePreview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkMobile",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkIos",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessagePreview_brandMessagePreview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "to",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatBubbleType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "carousel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wideItemList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "video",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commerce",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandMessageMessageButton",
          "kind": "LinkedField",
          "name": "buttons",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkType",
              "storageKey": null
            },
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandMessageMessageCoupon",
          "kind": "LinkedField",
          "name": "coupon",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkPc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkAndroid",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessagePreview",
  "abstractKey": null
};
})();

(node as any).hash = "6933be8df1aab1dcefda547700fcd942";

export default node;
